export default function shouldShowTemporaryUnlockedSamplesBannerSelectUtil () {
  return false
  // const {
  //   isEligibleToTemporaryUnlockedSamples,
  //   timeRemaining,
  //   shouldShowPostSampleModalOrBanner,
  //   isInGiftingMode
  // } = props
  //
  // const res = (
  //   !isInGiftingMode &&
  //   !isGiftUrlLocationUtil() &&
  //   isEligibleToTemporaryUnlockedSamples &&
  //   !!shouldShowTemporaryUnlockedSamplesBannerUtil(timeRemaining) &&
  //   !shouldShowPostSampleModalOrBanner &&
  //   !isPostSampleSurveyUrlLocationUtil() && !(isBlackFridayDateUtil() || isCyberMondayDateUtil())
  // )
  //
  // const debugProps = {
  //   props,
  //   res
  // }
  // logUtil('shouldShowTemporaryUnlockedSamplesBannerSelectUtil').debug('debugProps=', debugProps)
  // return res
}
